window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--sm-up': '(min-width: 576px)',
  '--md-up': '(min-width: 768px)',
  '--lg-up': '(min-width: 992px)',
  '--xl-up': '(min-width: 1200px)',
  '--xxl-up': '(min-width: 1400px)',
  '--xxxl-up': '(min-width: 1600px)',
  '--xs-down': '(max-width: 575.98px)',
  '--sm-down': '(max-width: 767.98px)',
  '--md-down': '(max-width: 991.98px)',
  '--lg-down': '(max-width: 1199.98px)',
  '--xl-down': '(max-width: 1399.98px)',
  '--xxl-down': '(max-width: 1599.98px)',
};
